import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

export type SupportedLanguage = 'en' | 'ne';

export function useLanguage() {
  const { i18n, t } = useTranslation();

  const currentLanguage = (i18n.language || 'en') as SupportedLanguage;

  const setLanguage = useCallback((lang: SupportedLanguage) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('i18nextLng', lang);
  }, [i18n]);

  const toggleLanguage = useCallback(() => {
    const next = currentLanguage === 'en' ? 'ne' : 'en';
    setLanguage(next);
  }, [currentLanguage, setLanguage]);

  return {
    language: currentLanguage,
    setLanguage,
    toggleLanguage,
    t,
  };
}
